module.exports = __webpack_public_path__ + "media/images/patent/z_4-e4cf8d8791921cbbfb723f3459dd7c00.png";